---
de:
  errors:
    invalid_number: Bitte geben Sie eine gültige Zahl ein
